module.exports = __webpack_public_path__ + "static/media/ic_gift-card-primary.f493092a.svg";